/**
 * UI utilities module for the inventor form
 */
class InventorFormUI {
    constructor() {
        this.inventorForm = document.querySelector('.inventor-form-container');
        this.mndaForm = document.querySelector('.mnda-form');
    }

    /**
     * Shows a success banner with the given message
     */
    showSuccessBanner() {
        const banner = document.createElement('div');
        banner.className = 'success-banner';
        banner.innerHTML = `
            <div class="success-content">
                <div class="success-icon">✓</div>
                <h3>Form Submitted Successfully!</h3>
                <p>Thank you for your submission. We will review your inventor application and get back to you soon.</p>
                <button onclick="this.parentElement.parentElement.remove()" class="close-btn">×</button>
            </div>`;
        
        document.body.appendChild(banner);
        
        // Auto-remove after 10 seconds
        setTimeout(() => {
            if (banner.parentElement) {
                banner.remove();
            }
        }, 10000);
    }

    /**
     * Shows an error message to the user
     * @param {string} message - The error message to display
     */
    showError(message) {
        alert(message);
    }

    /**
     * Updates button state during form submission
     * @param {HTMLButtonElement} button - The submit button
     * @param {boolean} isLoading - Whether the form is being submitted
     */
    updateSubmitButtonState(button, isLoading) {
        button.textContent = isLoading ? 'Submitting...' : 'Submit';
        button.disabled = isLoading;
    }

    /**
     * Fills the MNDA form with inventor form data
     * @param {Object} formData - The inventor form data
     */
    fillMNDAForm(formData) {
        const selectors = {
            'input-address-street': formData.streetAddress,
            'input-address-city': formData.city,
            'input-address-country-city-postcode': `${formData.stateProvince}, ${formData.city}, ${formData.postalCode}`,
            'input-email': formData.email,
            'input-phone': formData.phone,
            'input-name-submission': formData.submissionName,
            'input-name': `${formData.firstName} ${formData.lastName}`,
            'input-date': new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        };

        Object.entries(selectors).forEach(([className, value]) => {
            const element = document.querySelector(`.mnda-form-input.${className}`);
            if (element) {
                element.innerHTML = value;
            }
        });
    }

    /**
     * Switches between inventor form and MNDA form
     * @param {boolean} showMNDA - Whether to show the MNDA form
     */
    switchForms(showMNDA) {
        this.mndaForm.style.display = showMNDA ? 'block' : 'none';
        this.inventorForm.style.display = showMNDA ? 'none' : 'block';
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /**
     * Sets up event listeners for form navigation
     * @param {Function} onBack - Callback for back button click
     */
    setupNavigation(onBack) {
        const backButton = document.querySelector('.btn-back');
        if (backButton) {
            backButton.addEventListener('click', () => {
                this.switchForms(false);
                if (onBack) onBack();
            });
        }
    }
}

// Export for use in other modules
window.InventorFormUI = InventorFormUI;
